import { render, staticRenderFns } from "./LineGraphBehaviorEditor.vue?vue&type=template&id=6b195e8b&scoped=true&"
import script from "./LineGraphBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./LineGraphBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./LineGraphBehaviorEditor.vue?vue&type=style&index=0&id=6b195e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b195e8b",
  null
  
)

export default component.exports